import { useTrans, Trans } from "@/i18n"

import { FiChevronDown, FiInfo } from "@/lib/icons"

import { EXTERNAL_PLATFORM_ZONHUB_MANGOPAY_FAQ_URL } from "@/lib/env"

const ROWS: { titleKey: string; bodyKey: string }[] = [
	{
		titleKey: "investor:mangopay.about.when.title",
		bodyKey: "investor:mangopay.about.when.body",
	},
	{
		titleKey: "investor:mangopay.about.what.title",
		bodyKey: "investor:mangopay.about.what.body",
	},
	{
		titleKey: "investor:mangopay.about.safety.title",
		bodyKey: "investor:mangopay.about.safety.body",
	},
]

export function ScaAboutDisclosure() {
	const t = useTrans("investor")

	return (
		<details className="group mb-4 rounded-md border border-gray-200 bg-gray-50 text-sm text-gray-600">
			<summary className="flex cursor-pointer list-none items-center gap-2 p-3 font-medium text-gray-900 [&::-webkit-details-marker]:hidden">
				<FiInfo className="size-4 shrink-0 text-gray-500" />
				<span className="flex-1">
					{t("investor:mangopay.about.summary")}
				</span>
				<FiChevronDown className="size-4 shrink-0 transition-transform group-open:rotate-180" />
			</summary>
			<div className="space-y-2 border-t border-gray-200 p-3">
				<p>{t("investor:mangopay.about.intro")}</p>
				<dl className="space-y-2">
					{ROWS.map((row) => (
						<div key={row.titleKey}>
							<dt className="font-medium text-gray-900">
								{t(row.titleKey)}
							</dt>
							<dd>{t(row.bodyKey)}</dd>
						</div>
					))}
				</dl>
				<p>
					<Trans
						i18nKey="investor:mangopay.about.more"
						components={{
							/* oxlint-disable jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label */
							a: (
								<a
									className="text-secondary-700 font-medium"
									href={
										EXTERNAL_PLATFORM_ZONHUB_MANGOPAY_FAQ_URL
									}
									target="_blank"
									rel="noreferrer"
								/>
							),
							/* oxlint-enable jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label */
						}}
					/>
				</p>
			</div>
		</details>
	)
}
